<template>
  <modal :show.sync="showModal" size="lg">
    <h6 slot="header" class="modal-title">Ingresar nueva materia asegurada</h6>
    <form class="needs-validation" id="formCreateMateria"
        @submit.prevent="sendForm">
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre"
                      name="nombre"
                      placeholder="Ingrese un nombre"
                      :error="getError('nombre')"
                      v-validate="'required'"
                      v-model="model.name">
          </base-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Descripcion"
                      name="descripcion"
                      placeholder="Ingrese la descripción de la materia asegurada"
                      :error="getError('descripcion')"
                      v-validate="'required'"
                      v-model="model.descripcion">
          </base-input>
        </div>
      </div>
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Sponsor"
                            v-model="model.sponsor"
                            :error="getError('Sponsor')"
                            v-validate="'required'"
                            name="Sponsor"
                >
                    <el-select  v-model="model.sponsor" filterable
                                placeholder="Seleccione sponsor">
                        <el-option v-for="option in selectSponsors"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
            <card>
                <div class="row ">
                    <div class="col col-md-6 d-flex justify-content-center">
                        <base-input label="Nombre atributo:" v-model="nombre_nuevo" type="text"></base-input>
                    </div>
                    <div class="col col-md-6 d-flex justify-content-center">
                        <base-input label="Instancia requerida:" >
                            <!--<input type="text" class="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="button-addon2">-->
                            <el-select   v-model="valueTipoCampo"
                                        placeholder="Seleccione una opción...">
                                <el-option v-for="option in selectTiposCampos"
                                            :key="option.label"
                                            :label="option.label"
                                            :value="option.value">
                                </el-option>
                            </el-select>
                        </base-input>
                    </div>
                    
                </div>
                <div class="row">
                    <div class="col col-md-4 offset-md-1  justify-content-center">
                        
                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">/</span>
                                </div>
                                <input type="text" v-model="regex" class="form-control" placeholder="" >
                                <div class="input-group-append">
                                  <span class="input-group-text" id="basic-addon2">/g</span>
                                </div>
                            </div>
                        </div>
                        
                        
                        
                        <!--
                        <base-input label="Expresión regular:" v-model="regex" type="text">
                          <div class="input-group-prepend">
                              <span class="input-group-text" id="basic-addon1">/</span>
                          </div>
                          <input type="text" class="form-control" >
                          <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon2">/g</span>
                          </div>
                        </base-input>
                        -->
                        <small id="emailHelp" class="form-text text-muted">*Campo opcional para validación. Ingresar expresion regular. <a @click="openModalRegex" href="#"><i  class="fa fa-question-circle" aria-hidden="true"></i></a></small>
                      
                    </div>
                    <div class="col col-md-4 offset-md-2 d-flex align-content-center flex-wrap">
                        <base-button @click="agregarAtributo" type="default">Agregar</base-button>
                    </div>
                </div>
                <div class="row">
                    <p class="lead" style="margin-bottom: 0px">
                        Estos son los atributos que se almacenarán de esta materia asegurada
                    </p>
                </div>
                <div class="row">
                    <div class="table-responsive">
                        <base-table class="table  mt-5"
                                    :data="model.atributos">
                            <template slot="columns">
                                <th class="text-center px-0 bg-transparent" scope="col">
                                <span class="text-light font-weight-700">Nombre atributo</span>
                                </th>
                                <th class="text-center bg-transparent" scope="col">Instancia</th>
                                <th class="text-center bg-transparent" scope="col">Expresión regular</th>
                                <th></th>
                            </template>
                            
                            <template slot-scope="{row,index}">
                                <td class="text-center px-0">{{row.nombre}} </td>
                                <!--<td class="text-center" v-html="row.tipo_campo"></td>-->
                                <td class="text-center">{{row.momento == 'venta' ? 'Al momento de la venta' : 'Al momento de siniestro'}}</td>
                                <td class="text-center">{{row.regex}}</td>
                                
                                <td class="text-center"><base-button @click="borrarAtributo(index)"  type="danger" size="sm" >X</base-button></td>

                            </template>
                            
                        </base-table>
                    </div>
                </div>
                
            </card>

        </div>
      </div>
      <div class="container mt-2">
        <div class="form-row">
          <h4>Tipos de Siniestros Disponibles</h4>
          <div class="mt-1 col-md-12 d-flex flex-wrap">
            <base-checkbox v-for="(item,indice) in tipos_permisos" :key="indice" class="mb-3 mr-2" v-model="tiposPermisosModel[indice].value">
                {{item.name}}
            </base-checkbox>
          </div>
        </div>
      </div>
    </form>

    <template slot="footer">
      <base-button type="primary" nativeType="submit" form="formCreateMateria">Guardar Cambios</base-button>
      <base-button type="link" class="ml-auto" @click="showModal = false">Cancelar</base-button>
    </template>
    <modal :show.sync="modalRegex">
      <h6 slot="header" class="modal-title">¿Qué es una expresión regular?</h6>
      <p >Las expresiones regulares son patrones utilizados para encontrar una determinada combinación de caracteres dentro de una cadena de texto. <a target="_blank" href="https://www.adictosaltrabajo.com/2015/01/29/regexsam/">Mas información.</a></p>
      <p>Puedes probar tu expresión regular en <a target="_blank" href="https://regexr.com/">esta pagina web</a>.</p>
      <template slot="footer">
        <base-button type="link" class="ml-auto" @click="modalRegex = false">OK</base-button>
      </template>
    </modal>
  </modal>
</template>
<script>
  import { Select, Option } from 'element-ui';
  import BaseTable from '@/components/BaseTable';

  export default {
    components: {
        BaseTable,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
      return {
        tipos_permisos: [],
        tiposPermisosModel: [],
        validated: false,
        model: {
          name: '',
          atributos: [],
          descripcion: '',
          sponsor: undefined
        },
        valueTipoCampo: undefined,
        showModal: false,
        selectTiposCampos: [
            {label: 'Al momento de la venta del plan', value: 'venta'},
            {label: 'Al momento del siniestro', value: 'siniestro'}
        ],
        nombre_nuevo: '',
        selectSponsors: [],
        regex: '',
        modalRegex: false,
      }
    },
    methods: {
      openModalRegex(){
        console.log('proximamente regex');
        this.modalRegex = true;
      },
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
          //throw new Error('hno ke wea esta wea');
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      sendForm(){
        var vm = this;
        if( this.tiposPermisosModel.every( e => e.value == undefined || !e.value ) ){
          return this.$notify({
            message: 'Debes configurar al menos un tipo de siniestro para esta materia',
            type: 'warning'
          });
        }
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);
          if( response ){
            
            vm.axios({
                method: 'POST',
                url: 'api/store_create_materia',
                data: {   
                        nombre: vm.model.name, 
                        atributos: vm.model.atributos,
                        descripcion: vm.model.descripcion,
                        sponsor: vm.model.sponsor,
                        tipos_siniestros: vm.tiposPermisosModel.filter( e => e.value != undefined && e.value === true).map( e => e.id)
                      }
            }).then( response => {
              vm.$notify({
                      message: 'Materia creada exitosamente!',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'success'
                  });
              // Cerrar el Modal
              vm.showModal = false;
              // Emitir evento para que actualize la tabla de usuarios
              vm.$emit('successSending');
            }).catch( error => {
                
                if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
                }else{
                  console.log(error);
                  vm.$notify({
                        message: 'Hubo un error, no se pudo agregar la nueva materia asegurada',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                }
            });
          }
        }).catch( reason => {
          console.log(reason);
        });
        
      },
      borrarAtributo(indice)
      {
          this.model.atributos.splice(indice,1);
      },
      agregarAtributo()
      {
          if( this.nombre_nuevo != '' && this.valueTipoCampo != '' && this.valueTipoCampo != undefined ){
              this.model.atributos.push( {nombre: this.nombre_nuevo, momento: this.valueTipoCampo, regex: this.regex} );
          }
          
      },
      fetchSponsorList()
      {
        var vm = this;
        this.axios({
          url: 'api/fetch_sponsor_list_from_create_materia',
          method: 'GET'
        }).then( response => {
          vm.selectSponsors = response.data;
          if(response.data.length == 1){
            vm.model.sponsor = response.data[0].value;
          }
        }).catch( error => {
          console.lof(error);
        })
        ;
      },
      fetchTipossiniestrosList(){
        var vm = this;
        this.axios({
          url: 'api/tipos_siniestros_list',
          method: 'GET'
        }).then( response => {
          vm.tipos_permisos = [];
          response.data.forEach( e => {
            vm.tiposPermisosModel.push({ id: e.id, name: e.name, value: false});
          });
          vm.tipos_permisos = response.data;
          
        }).catch( error => {
          console.log(error);
        });
      },
    },
    
    created()
    {
      this.$parent.$on('showModalCreateMateria', () => { 
        this.showModal = true; this.fetchSponsorList(); this.fetchTipossiniestrosList();
        this.model.atributos = [ {nombre: 'Sku Producto', momento: 'venta'}, {nombre: 'Numero de boleta', momento:'venta'} ];
        } );
      
    }
  }
</script>
<style>
</style>
